<div
    class="flows-input-spinner"
    *ngIf="wizardSvc.isOffModalMatchflow && !wizardSvc.completed; else placeholderForm"
  >
  <mat-spinner
    color="primary"
    diameter="88"
    strokeWidth="6"
    aria-label="Loading Match Flow"
  ></mat-spinner>
</div>
<ng-template #placeholderForm>
  <form class="decline-theme" sonderMediaqueryClass="mq">
    <sonder-form-field>
      <input
        matInput
        #input
        placeholder="What's your first name?"
        data-test="first-name-input"
      >
      <button
        matSuffix
        mat-icon-button
        type="submit"
      >
        <mat-icon data-sonder-flow-trigger="click" data-test="arrow-forward-button">arrow_forward</mat-icon>
        <span class="cdk-visually-hidden">Continue</span>
      </button>
    </sonder-form-field>
  </form>
</ng-template>
